import React, { memo } from 'react';
import useTheme from '@nykaa/ui-components/themes/hooks/useTheme';

import StarHalfFilled from '@nykaa/ui-components/Icons/star-half-filled';
import StarFilled from '@nykaa/ui-components/Icons/star-filled';
import StarEmpty from '@nykaa/ui-components/Icons/star';
import { Star } from './styles';
import { Theme } from '@nykaa/ui-components/themes/types';

interface IStarRating {
  maxCount: number;
  activeCount: number;
  size: string;
  className: string;
  onChange: (val: number) => void;
  activeColor?: string;
}
const LABEL = 'Star Rating';

function StarRating({
  maxCount = 5,
  activeCount = 0,
  className,
  onChange,
  size,
  activeColor,
}: Partial<IStarRating>) {
  const theme: Theme = useTheme();

  const onClick = (index: number) => {
    if (onChange === undefined) return;

    onChange(index);
  };
  return (
    <div className={className} data-at="star-rating">
      {Array(maxCount)
        .fill(1)
        .map((_, indx) => {
          const ratingDiff = activeCount - indx;

          return ratingDiff >= 1 ? (
            <Star
              key={indx + 1}
              className={'active'}
              onClick={() => onClick(indx + 1)}
              aria-label={LABEL}
            >
              <StarFilled color={activeColor || theme?.colors?.textPrimary} size={size} />
            </Star>
          ) : ratingDiff > 0 ? (
            <Star
              key={indx + 1}
              className={'in-active'}
              onClick={() => onClick(indx + 1)}
              aria-label={LABEL}
            >
              <StarHalfFilled color={activeColor || theme?.colors?.textPrimary} size={size} />
            </Star>
          ) : (
            <Star
              key={indx + 1}
              className={'in-active'}
              onClick={() => onClick(indx + 1)}
              aria-label={LABEL}
            >
              <StarEmpty size={size} />
            </Star>
          );
        })}
    </div>
  );
}

export default memo(StarRating);
